export const LOGIN_USER: string = "LOGIN_USER";
export const LOGOUT_USER: string = "LOGOUT_USER";
export const MODE_HANDLER: string = "MODE_HANDLER";
export const TOKEN_USER_DATA_HANDLER: string = "TOKEN_USER_DATA_HANDLER";
export const LOADING: string = "LOADING";
export const OTPEMAIL: string = "OTPEMAIL";
